<template>
  <van-nav-bar
    id="navbar"
    :title=navbarName
    left-text="返回"
    right-text="首页"
    left-arrow
    @click-left="onClickLeft"
    @click-right="onClickRight"
    class="bg-blue-linear text-white"
    :fixed="true"
  >
    <!-- <template #title>
      {{navbarName}}
    </template> -->
    <template #right>
      <van-icon name="wap-home" size="18" />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'navbar',
  data () {
    return {
      // msg: 'Welcome to Your Vue.js App'
      navbarName: '石家庄电子信息学校'
    }
  },
  created() {
    var routeName = this.$route.name
    var routeParams = this.$route.params.type
    // console.log(routeName)
    // console.log(routeParams.type)
    // if(routeName == "forum") {
    //   if(routeParams == "pediatric") {
    //     this.navbarName = "儿科论坛"
    //   }
    //   if(routeParams == "healthy") {
    //     this.navbarName = "儿童健康论坛"
    //   }
    // }

  },
  mounted() {
    // var routeName = this.$route.name
    // var navbarName = ""
    // switch(routeName) {
    //   case "intro":
    //     navbarName = "学会简介"
    //     break;
    //   case "category":
    //     navbarName = "文章列表"
    //     break;
    //   case "details":
    //     navbarName = ""
    //     break;
    //   case "forum":
    //     navbarName = "论坛"
    //     break;
    //   case "register":
    //     navbarName = "会员注册"
    //     break;
    //   case "member":
    //     navbarName = "会员列表"
    //     break;
    //   defaul:
    //     break;

    // }
    // this.navbarName = navbarName
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
       this.$router.push({ path:'/'  })
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/navbar/navbar.vue